import { createGlobalStyle } from 'styled-components';
// @ts-ignore
import modernNormalize from 'styled-modern-normalize';

import { fontFaces as defaultFontFaces } from '@spazious/dollhouse-assets';

import { createFontFaces } from './GlobalStylesConstants.js';
import { GlobalStylesThemes } from './GlobalStylesTheme.js';
import { GlobalStylesTokens } from './GlobalStylesTokens.js';
import { FontFaces } from './GlobalStylesTypes.js';
import { printFontFaces } from './GlobalStylesUtils.js';

export const GlobalStyles = createGlobalStyle<{
  fontFaces?: FontFaces;
}>`
  ${modernNormalize}
  ${GlobalStylesTokens}
  ${GlobalStylesThemes}
  ${({ fontFaces = defaultFontFaces }) => printFontFaces(createFontFaces(fontFaces))}
  html {
    --spacing-padding: 8px;
    --spacing-gap: 8px;
    --spacing-block: 8px;
    --shape-rounded-radius: 8px;
    color: var(--spz-sys-color-on-surface);
  }
`;
